import { blogZeroStateRedirect, campaignAssistantRedirect, clipCreatorRedirect, walkthrough } from '../intents/intentLinks';
import { getQueryParams } from '../routing/getQueryParams';
import { getHublet } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
export const getCampaignAssistantRedirect = state => {
  return campaignAssistantRedirect(getPortalId(state), getHublet(state), getQueryParams());
};
export const getBlogIdeasGeneratorRedirect = state => {
  return blogZeroStateRedirect(getPortalId(state), getHublet(state), getQueryParams());
};
export const getClipCreatorRedirect = state => {
  return clipCreatorRedirect(getPortalId(state), getHublet(state));
};
export const getGuideCreatorRedirect = state => {
  return walkthrough(getPortalId(state));
};